import React, { useMemo, useState } from 'react';
import { ScommesseAccordion } from 'components/scommesseAccordion';
import ScommesseTipoList from 'components/scommesseTipoList/ScommesseTipoList';
import { SportsTipoScommessa } from 'types/swagger';
import { normalizeKeyStringList } from 'features/sport';
import { useIsAtLeastOneActive } from 'features/sport/hooks';
import styles from './ScommesseConditionalAccordion.module.scss';

export interface ScommesseConditionalAccordionProps {
  tipoScommessa: SportsTipoScommessa;
  defaultOpened?: string;
  avvenimentoKey: string;
  isVisualizzazioneEstesa: boolean;
}

export const ScommesseConditionalAccordion = ({
  tipoScommessa,
  defaultOpened,
  avvenimentoKey,
  isVisualizzazioneEstesa,
}: ScommesseConditionalAccordionProps) => {
  const { descrizione, descrizioneTrKey, infoTipoScommessaKeyStringList } = tipoScommessa ?? {};
  const keys = useMemo(
    () => normalizeKeyStringList(infoTipoScommessaKeyStringList, avvenimentoKey),
    [infoTipoScommessaKeyStringList, avvenimentoKey]
  );
  const isAtLeastOneActive = useIsAtLeastOneActive(keys);

  // Assumiamo che se non è stato passato un default siano tutti aperti (?)
  const openedProp = defaultOpened ? { defaultOpened: defaultOpened } : { allOpened: true };

  const [isTooltipClicked, setIsTooltipClicked] = useState<boolean>(false);

  return isAtLeastOneActive ? (
    <ScommesseAccordion
      key={`Conditional-Accordion-${avvenimentoKey}`}
      text={descrizione}
      textTrKey={descrizioneTrKey}
      isVisualizzazioneEstesa={isVisualizzazioneEstesa}
      isTooltipClicked={isTooltipClicked}
      {...openedProp}
      infoTipoScommessaKeyStringList={infoTipoScommessaKeyStringList ?? []}
      avvenimentoKey={avvenimentoKey!}
      rootClassName={styles.accordionContainer}
      childrenClassName={styles.childrenContainer}
    >
      <ScommesseTipoList
        key={`Tipo-List-${avvenimentoKey}`}
        avvenimentoKey={avvenimentoKey!}
        isVisualizzazioneEstesa={isVisualizzazioneEstesa}
        infoTipoScommessaKeyStringList={infoTipoScommessaKeyStringList ?? []}
        setIsTooltipClicked={setIsTooltipClicked}
        isTooltipClicked={isTooltipClicked}
      />
    </ScommesseAccordion>
  ) : (
    <React.Fragment key={`Conditional-Accordion-${avvenimentoKey}`} />
  );
};
